<template>
    <div id="shop-sort" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#sort" href="/build/assets/icons.svg#sort" />
                </svg>
                Sort By
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>
        <div class="offcanvas__body">
            <div class="shop-sidebar__section">
                <div class="shop-sidebar__section__heading hidden-md">
                    <h3>Specials</h3>
                    <a href="#" class="shop-sidebar__clear" @click.prevent="clearFilter">Clear all</a>
                </div>
                <select class="form-select" v-model="sort">
                    <option
                        v-for="opt in sorted_options"
                        :key="opt.value"
                        :value="opt.value"
                    >
                        {{ opt.value === sort ? `Sort: ${opt.label}` : opt.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div id="shop-filter" class="offcanvas offcanvas-md">
        <div class="offcanvas__header">
            <h5 class="h3 offcanvas__title">
                <svg focusable="false" role="img">
                    <use xlink:href="/build/assets/icons.svg#refine" href="/build/assets/icons.svg#refine" />
                </svg>
                Refine
            </h5>
            <a class="btn-close" href="#" data-ec-dismiss="offcanvas">
                <span class="visually-hidden">Close</span>
            </a>
        </div>

        <div class="offcanvas__body">
            <div
                class="shop-sidebar__section"
                v-for="(options, groupKey) in filters.filters"
                :key="groupKey"
            >
                <div class="shop-sidebar__section__heading">
                    <h3>{{ formatLabel(groupKey) }}</h3>
                </div>

                <div class="form-check" v-for="value in options" :key="value">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`${groupKey}_${value}`"
                        :value="value"
                        :checked="selected_filters[groupKey]?.includes(value)"
                        @change="updateFilters(groupKey, value)"
                    />
                    <label class="form-check-label" :for="`${groupKey}_${value}`">
                        {{ filters.labels[value] }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {computed, ref, watch} from "vue";

const props = defineProps({
    filters: Object,
    selected_filters: Object,
    initial_sort: {
        type: String,
        default: 'title_asc',
    },
})

const sort = ref(props.initial_sort)
const sort_options = [
    { value: 'title_asc',   label: 'Product Name (A–Z)' },
    { value: 'title_desc',  label: 'Product Name (Z–A)' },
    { value: 'from_price_asc',  label: 'Price (Low to High)' },
    { value: 'from_price_desc', label: 'Price (High to Low)' },
];

const active_option = computed(
    () => sort_options.find(o => o.value === sort.value) || sort_options[0]
)

const other_options = computed(
    () => sort_options.filter(o => o.value !== sort.value)
)

const sorted_options = computed(
    () => [active_option.value, ...other_options.value]
)

watch(sort, newVal => {
    emit('update', 'sort', newVal)
})

const emit = defineEmits(['update', 'clear'])

const updateFilters = (category, value) => {
    emit('update', category, value)
}

const clearFilter = () => {
    emit('clear')
}

// Check if there's a custom name for this filter group
const formatLabel = (key) => {

    if (props.filters.custom_names && props.filters.custom_names[key.toLowerCase()]) {
        return props.filters.custom_names[key.toLowerCase()];
    }

    // TODO : This also should really really pull from the landlord data...
    return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
}
</script>
